import React from "react";
import { cn } from "utils";
import Button from "./Button";

const SubmitButton = ({
    submitText = "Submit",
    cancelText = "Cancel"
}) => {
    return (
        <div className={cn("submit-container")}>
            <Button buttonType="flat" type='submit'>{submitText}</Button>
            <Button variant="text">{cancelText}</Button>
        </div>
    )
}

export default SubmitButton;